import { CommandGetAnalytics } from "./commands/cmdGetAnalytics";
import { CommandGetAdMedia } from "./commands/cmdGetAdMedia";

export interface AnalyticsFilters {
    organizationIds: number[];
    days: string;
    engagement?: number | null;
    objective?: number | null;
    launch?: number | null;
    /** Campaign status filter: ALL (default), UPCOMING, LIVE or ENDED. */
    status?: string | null;
    employeeId?: number | null;
    /** Override the default chart list. Comma-separated chart IDs. */
    charts?: string;
}

export class AnalyticsService {
    async getAnalytics(filters: AnalyticsFilters) {
        const cmd = new CommandGetAnalytics();
        return await cmd.run(filters);
    }

    async getAdMedia(organizationIds: number[], adIds: number[]) {
        const cmd = new CommandGetAdMedia();
        return await cmd.run(organizationIds, adIds);
    }
}
